<template>
    <div class="partner-report-settings py-3 mb-3">
        <CRow form class="mb-3">
            <CCol
                tag="label"
                sm="3"
                class="col-form-label">Частота рассылки отчетов</CCol>
            <CCol sm="9">
                <CSelect
                    inline
                    :value="partner.report_frequency"
                    :options="report_frequencies"
                    @change="setFrequency($event.target.value)"
                />
            </CCol>
        </CRow>
        <CRow>
            <CCol
                col="3"
                tag="label"
                class="col-form-label">Получатели отчетов</CCol>
            <CCol col="9" class="pl-2">
                <CRow
                    v-for="(email, index) of partner.report_emails"
                    :key="`report_emails-${ index }`"
                    class="d-flex justify-content-start pl-1 pr-3"
                >
                    <CCol col="9">
                        <CInput
                            :value="email"
                            @change="setEmail($event, index)"
                            placeholder="Email"
                        />
                    </CCol>
                    <CCol col="3">
                        <CButton
                            shape="pill"
                            color="danger"
                            variant="ghost"
                            @click="removeEmail(index)"
                        >
                            <div class="d-flex">
                                <CIcon
                                    :height="24"
                                    :content="$options.icons.cilTrash"
                                    class="handle"
                                />&nbsp;Удалить
                            </div>
                        </CButton>
                    </CCol>
                </CRow>
                <CButton
                    shape="pill"
                    color="success"
                    variant="ghost"
                    @click="addEmail"
                >
                    <CIcon
                        :height="24"
                        :content="$options.icons.cilPlus"
                        class="handle"
                    />
                    Добавить
                </CButton>
            </CCol>
        </CRow>
    </div>
</template>

<script>
    import { cilPlus, cilTrash } from '@coreui/icons';
    import { REPORT_FREQUENCY, REPORT_FREQUENCY_TITLE } from '@/utils/partner';
    export default {
        icons: {
            cilPlus,
            cilTrash
        },

        props: {
            partner: {
                type: Object,
                default: () => {},
            },
        },

        computed: {
            report_frequencies() {
                return [
                    { value: REPORT_FREQUENCY.MONTH_ONCE, label: REPORT_FREQUENCY_TITLE[REPORT_FREQUENCY.MONTH_ONCE] },
                    { value: REPORT_FREQUENCY.MONTH_TWICE, label: REPORT_FREQUENCY_TITLE[REPORT_FREQUENCY.MONTH_TWICE] },
                    { value: REPORT_FREQUENCY.WEEK_ONCE, label: REPORT_FREQUENCY_TITLE[REPORT_FREQUENCY.WEEK_ONCE] },
                    { value: REPORT_FREQUENCY.DAY_ONCE, label: REPORT_FREQUENCY_TITLE[REPORT_FREQUENCY.DAY_ONCE] },
                ]
            }
        },

        methods: {
            setFrequency(value) {
                this.$emit('set-frequency', +value);
            },
            setEmail(value, index) {
                const emails = this.partner.report_emails;
                emails[index] = value;
                this.$emit('set-emails', emails);
            },
            addEmail() {
                const emails = this.partner.report_emails;
                emails.push('');
                this.$emit('set-emails', emails);
            },
            removeEmail(index) {
                const emails = this.partner.report_emails;
                emails.splice(index, 1);
                this.$emit('set-emails', emails);
            }
        },
    };
</script>

<style>
.partner-report-settings {
    border-top: 1px solid #c4c9d0;
    border-bottom: 1px solid #c4c9d0;
}
</style>
